import React from 'react';
import { HomePageContainer } from './homepageNR.styles';




const HomePageNR = () => {

    const width = window.screen.width;
   
    

    
    return (
        <HomePageContainer width={width}>
            <h1 style={{ color:"darkblue", textAlign: "center"}}>Reservations are no longer required for Masses at St. Nicholas and St. William Parish.</h1>
        </HomePageContainer>
    );
};


export default HomePageNR;